import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import styled from "styled-components";
import { sanitize } from "dompurify";

const HiddenIcon = styled(FontAwesomeIcon)`
    visibility: hidden;
`

const WideTooltip = styled(Tooltip)`
    > .tooltip-inner {
        max-width: 500px;
    }
`

const InfoBubble = ({
    className,
    iconClassName,
    showBubble,
    info,
    ...rest
}) => {
    const IconComponent = showBubble ? FontAwesomeIcon : HiddenIcon

    return <OverlayTrigger
        key="trigger"
        className={className}
        overlay={(props) => <WideTooltip {...props}>
            {/* Dangerously setting innerHTML to use HTML strings from DB */}
            <div className="text-start" dangerouslySetInnerHTML={{ __html: sanitize(info) }} />
        </WideTooltip>}
    >
        <IconComponent
            className={`has-pointer ${iconClassName ?? ""}`}
            icon="circle-info"
            size="xl"
            {...rest}
        />
    </OverlayTrigger>;
};

export default InfoBubble;
